import { LoginForm, loginFormSchema } from '@univdiam/ui/customComponents/LoginForm'
import { OtpForm, otpFormSchema } from '@univdiam/ui/customComponents/OtpVerifyForm'
import logo from "@/assets/univdiam.png"
import z from 'zod'
import RightContainer from '@/components/auth/RightContainer'
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import api from '@/http/api'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import { maskVerificationId } from '@/lib/maskVerified'
import { toast } from 'sonner'
import { Toaster } from "@univdiam/ui/components/sonner"
import { useAuthStore, useSessionStore } from '@/store'
const login = (data: { identifier: string, identifierType: string }) => {
  return api.post(`/customer/login`, data);
}
const verifyLogin = (data: { verificationId: string, code: string, channel: string }) => {
  return api.post(`/customer/verify/login`, data);
}

// channel = sms or phone
const sendOTPtoUser = (data: { verificationId: string, channel: string }) => {
  return api.post(`/customer/send-otp`, data);
}
const Login = () => {
  const { setSessionExpired } = useSessionStore()
  const location = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const verification_status = searchParams.get('verification_status')
  const verification_id = searchParams.get('verification_id')
  const channel = searchParams.get('channel')
  const [inputType, setInputType] = useState<'email' | 'phone'>('email');
  const { setUser } = useAuthStore()
  const [timeExpired, setTimeExpired] = useState(false)
  const setQueryParams = (paramsObj: Record<string, string>) => {
    const params = new URLSearchParams(location.search);

    Object.entries(paramsObj).forEach(([key, value]) => {
      params.set(key, value);  // or append if you want duplicate keys
    });

    navigate(`${location.pathname}?${params.toString()}`);
    // { replace: true }
  };


  const { mutate, isError, isPending, error } = useMutation({
    mutationFn: (values: z.infer<typeof loginFormSchema>) => {
      let identifier = values.identity
      if (inputType === 'phone') {
        // Send raw digits — backend getCustomer handles any format
        identifier = values.identity.replace(/\D/g, '')
      }
      return login({ identifier, identifierType: inputType })
    },
    onSuccess: async ({ data }, values) => {
      if (data?.success) {
        setQueryParams({
          verification_status: data.verificationStatus,
          verification_id: data.verificationId,
          channel: data.channel
        })
      } else {
        console.log(data)
        // make one more screen for showing email verification part
        if (data?.action === 'admin_verification') {
          navigate(`/onboard?name=${data?.customer}`)
        } else if (data?.action === 'email_verification') {
          navigate(`/onboard?name=${data?.customer}&email_verification=false&email=${encodeURIComponent(values.identity)}`)
        }
      }

    }
  })

  function onSubmit(values: z.infer<typeof loginFormSchema>) {
    mutate(values)
  }

  const { mutate: verifyOTP, error: otpError, isError: isOTPError, isPending: isOTPPending, reset: resetVerifyOTP } = useMutation({
    mutationFn: (values: { verificationId: string, code: string }) => {
      const data = { verificationId: values.verificationId, code: values.code, channel: channel! }
      return verifyLogin(data)
    },
    onSuccess: async ({ data }) => {
      console.log('data', data)
      if (data?.success) {
        setSessionExpired(false)
        setUser(data.user);
        navigate(`/`)
      }
    }
  })

  function onOtpSubmit(values: z.infer<typeof otpFormSchema>) {
    const code = values.otp
    if (verification_id) {
      verifyOTP({
        code,
        verificationId: verification_id
      })
    }
  }

  const { mutate: sendOTP, isError: isSendOTPError, isPending: isSendOTPPending } = useMutation({
    mutationFn: (values: { verificationId: string, channel: string }) => {
      return sendOTPtoUser(values)
    },
    onSuccess: async () => {
      toast.success(`OTP sent to ${maskVerificationId(verification_id!)}`, {
        position: 'top-center'
      })
      setTimeExpired(false)
      resetVerifyOTP()
    }
  })

  return (
    <div className='grid grid-cols-1 lg:grid-cols-2 min-h-screen'>
      <div className="flex flex-col justify-between min-h-screen p-[20px] lg:p-[40px] items-center w-full">
        {/* Centered content */}
        <div className="flex-1 flex items-center justify-center w-full">
          <div className="w-full max-w-[440px]">
            <img src={logo} alt="Univ Daim" />
            <p className="text-heading2 mt-[32px] mb-[12px] lg:mt-[64px]">Welcome</p>
            {/* <p className="text-heading6 text-secondary mt-[8px] mb-[32px]">
              Sign into Univ Diam Customs
            </p> */}
            {
              verification_status && verification_id ? <>
                <OtpForm handleSendOtp={() => sendOTP({
                  verificationId: verification_id!,
                  channel: channel!
                })} verification_id={verification_id!} onSubmit={onOtpSubmit} isError={isOTPError} isLoading={isOTPPending} isSendOTPError={isSendOTPError} isSendOTPPending={isSendOTPPending} timeExpired={timeExpired} setTimeExpired={setTimeExpired} error={otpError} />
              </> : <><LoginForm onSubmit={onSubmit} isError={isError} isLoading={isPending} error={error} inputType={inputType} setInputType={setInputType} />
                <p className="text-body2 text-highlight mt-[16px]">
                  Don't have an account?{" "}
                  <Link to={"/signup"}>
                    <span className="text-[#16111] font-[700] cursor-pointer underline">
                      Create one
                    </span>
                  </Link>
                </p></>
            }

          </div>
        </div>

        {/* Footer */}
        <div className="flex flex-col lg:flex-row items-center justify-center gap-[8px] lg:gap-[32px]">
          <p className='text-secondary text-caption2'>© 2026 Universal Diamonds. All rights reserved</p>
          <p className='text-caption2 text-[#202020] font-[500]'><Link to={'/'}>Privacy Policy</Link> • <Link to={
            '/'
          }>Terms & Condition</Link></p>
        </div>
      </div>
      <RightContainer />
      <Toaster />
    </div>
  )
}

export default Login